<template>
  <div class="location-create-section">
    <b-card>
      <div v-if="mode === 'create'">
        <h2 class="m__b--25">
          Create Location
        </h2>
      </div>

      <b-form>
        <b-form-group label="Name">
          <b-form-input v-model="itemData.name" placeholder="Name" />
        </b-form-group>
        <b-form-group label="Address">
          <b-textarea v-model="itemData.address" placeholder="Address" />
        </b-form-group>

        <b-form-group label="Description">
          <b-textarea
            v-model="itemData.description"
            placeholder="Description"
          />
        </b-form-group>
        <b-form-group label="Location">
          <div class="w__100 h--400">
            <mapbox-map
              v-if="reRender"
              ref="dataMapbox"
              :zoom="0"
              class="h__100 w__100"
              :access-token="accessToken"
              map-style="mapbox://styles/mapbox/streets-v9"
            >
              <mapbox-marker :lng-lat="position"></mapbox-marker>
              <MapboxGeocoder />
            </mapbox-map>
          </div>
        </b-form-group>
      </b-form>
    </b-card>

    <div class="float-to-right m__t--55 m__b--60">
      <b-button
        class="m__r--10 cancel action-push"
        @click="$router.replace('/home/location')"
        >Cancel</b-button
      >
      <b-button class="save action-push" @click="save">Save</b-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import {
  MapboxMap,
  MapboxMarker,
  MapboxGeocoder
} from '@studiometa/vue-mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
// import Store from '@/stores';
export default {
  name: 'Location',
  components: {
    MapboxMap,
    MapboxMarker,
    MapboxGeocoder
  },
  data() {
    return {
      reRender: true,
      map_result: null,
      accessToken: process.env.VUE_APP_MAPS_KEY,
      position: [0, 0],
      mode: 'create',
      currentData: 'account',
      itemData: {
        id: 0,
        name: null,
        address: null,
        description: null
      }
    };
  },
  watch: {
    'locationState.detail': function(newVal) {
      this.itemData = {
        id: newVal.id,
        name: newVal.name,
        address: newVal.address,
        description: newVal.description
      };
      this.position = [
        newVal.address_point ? newVal.address_point._longitude : 0,
        newVal.address_point ? newVal.address_point._latitude : 0
      ];
    }
  },
  computed: {
    ...mapState('StoreLocation', ['locationState'])
  },
  created() {
    const req = {
      sort: 'name',
      per_page: 100,
      page: 1,
      search: ''
    };
    this.$store.dispatch('StoreLocation/listLocation', req);

    if (this.$route.path.includes('create')) {
      this.mode = 'create';
    } else {
      this.mode = 'edit';
      this.$store.dispatch('StoreLocation/detailLocation', {
        id: this.$route.params.id
      });
    }
  },
  mounted() {
    this.map_result = this.$refs.dataMapbox.map;
  },
  methods: {
    save() {
      const req = {
        id: this.$route.params.id ? this.$route.params.id : 0,
        name: this.itemData.name,
        address: this.itemData.address,
        description: this.itemData.description,
        lat: this.map_result ? this.map_result.transform._center.lat : 0,
        lng: this.map_result ? this.map_result.transform._center.lng : 0
      };
      if (this.mode === 'create') {
        this.$store.dispatch('StoreLocation/createLocation', req);
      } else {
        this.$store.dispatch('StoreLocation/editLocation', req);
      }
    }
  }
};
</script>

<style lang="scss">
.location-create-section {
  h2 {
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 37px;
    color: #1d2d4e;
  }
  legend {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 37px;
    color: #1d2d4e;
  }
  .form-control::placeholder {
    color: #bdbdbd;
  }
  button.action-push {
    width: 147px;
    height: 45px;
    border-radius: 3px;
    border: unset;
    &.cancel {
      background: #ffffff;
      box-shadow: 0px 4px 20px #f0efec;
      color: #ababab;
    }
    &.save {
      background: #fb9c0a;
      box-shadow: 0px 4px 20px rgba(251, 156, 10, 0.3);
    }
  }
}
</style>
